import { gql } from '@apollo/client';

export const GET_TRIPS = gql`
  query GetTrips($filters: TripFilters, $page: Int, $limit: Int) {
    getTrips(filters: $filters, page: $page, limit: $limit) {
      data {
        id
        business_booking_id
        booking_id
        schedule_date
        created_date
        destination {
          formatted_address
          latitude
          longitude
        }
        origin {
          formatted_address
          latitude
          longitude
        }
        via {
          formatted_address
          latitude
          longitude
        }
        is_hourly
        estimated_time
        status
        fare {
          payment_method
        }
      }
      meta {
        current_page
        total_pages
        total_count
        has_next_page
        has_previous_page
      }
    }
  }
`;
